/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserFilters {
    getFixupPrototypeFunction() { return UserFilters.fixupPrototype; }

    static newInstance(model: Partial<UserFilters>): UserFilters {
        let obj = Object.assign(new UserFilters(), model);
        UserFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserFilters>): UserFilters {
        if (!model) return null;
        return UserFilters.newInstance(<UserFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserFilters) {
        if (!obj) return;

        models.UserFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserFilters): boolean {
        Object.setPrototypeOf(obj, UserFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Text search across username, first_name, last_name, email
     */
    search: string;

    /**
     * Filter by user status
     */
    status: string;

    /**
     * Filter by role id
     */
    role_id: string;

    /**
     * Filter users created on or after this date (YYYY-MM-DD)
     */
    created_after: string;

    /**
     * Filter users updated on or after this date (YYYY-MM-DD)
     */
    updated_after: string;

}
